import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getNav, getSettings } from "../lib/api";

const SiteContext = createContext({ settings: {}, nav: {}, ready: false });

export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [nav, setNav] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    Promise.all([getSettings().catch(() => ({})), getNav().catch(() => ({}))]).then(([s, n]) => {
      if (!alive) return;
      setSettings(s || {});
      setNav(n || {});
      setReady(true);
    });
    return () => {
      alive = false;
    };
  }, []);

  // Memoised so consumers only re-render when site data actually changes.
  const value = useMemo(() => ({ settings, nav, ready }), [settings, nav, ready]);
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}
